import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';

import { AppState } from 'app/types';
import { Loggable } from 'app/utils/logging/loggable';
import {
  IncomingMessage,
  IncomingMessageType,
  InitialStateMessage,
  StateChangeMessage,
} from 'messages/websocket.messages';

import { LeaveRoomType } from '../../social-leave-room/social-leave-room-type';
import SocialStateMachine from '../../social-state-machine/social-state-machine';
import { WebsocketService } from '../websocket.service';

@Injectable({
  providedIn: 'root',
})
export class RoomStateService extends Loggable {
  private store = inject<Store<AppState>>(Store);
  private websocketService = inject(WebsocketService);

  public leaveRoomSubject = new Subject<LeaveRoomType>();
  public leaveRoom$ = this.leaveRoomSubject.asObservable();

  public constructor() {
    super();
    this.setDisplayName('RoomStateService');

    this.websocketService.message$.subscribe((message) => this.handleWebsocketMessage(message));
  }

  private handleWebsocketMessage(msg: IncomingMessage): void {
    const { t: type } = msg;

    switch (type) {
      case IncomingMessageType.STATE_CHANGE:
        this.handleWebsocketState(msg);
        return;

      case IncomingMessageType.INIT_STATE:
        this.handleWebsocketState(msg);
        return;

      case IncomingMessageType.STATE_NOT_CHANGED: {
        SocialStateMachine.shared.onStateNotChanged(msg);
        return;
      }

      case IncomingMessageType.STATE_CHANGE_ERROR: {
        SocialStateMachine.shared.onStateChangeError(msg);
        return;
      }
    }
  }

  private handleWebsocketState(msg: InitialStateMessage | StateChangeMessage): void {
    this.info('STATE:', msg);

    SocialStateMachine.shared.onReceiveState(this.store, msg);
  }
}
